import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { Camera } from '@ionic-native/camera';


import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { NL_StokKarti } from './../../../models/NL_StokKarti';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-stok-resim-ekle-guncelle',
  templateUrl: 'stok-resim-ekle-guncelle.html',
})
export class StokResimEkleGuncellePage {
  stok: NL_StokKarti = new NL_StokKarti();
  base64Image = "";
  kayitliresim: any;
  resimBaslik = "";
  resimAciklama = "";
  sunucuadresi: any;
  guncellenecekelement:any={};
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public camera: Camera,
    public navParams: NavParams) {
    this.stok = navParams.get("stok");
    this.sunucuadresi = this.ortak.storageSunucuAdresiGetir;
  }


  fileUpload(event) {
    let fd = new FormData();
    fd.append('file', event.srcElement.files[0]);
    var file = event.srcElement.files[0]
    if (file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64Image = btoa(binaryString);
    this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;

  }

  FotografCek() {

    this.camera.getPicture({
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.CAMERA,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1000,
      targetHeight: 1000
    }).then((imageData) => {

      this.base64Image = imageData;
      this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
    }, (err) => {
      console.log(err);
    });
  }

  GaleriyeGit() {
    this.camera.getPicture({
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1000,
      targetHeight: 1000
    }).then((imageData) => {

      this.base64Image = imageData;
      this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
    }, (err) => {
      console.log(err);
    });
  }

  resimKaydet() {

    var resimAdi = this.ortak.createGuid();
    var formData = new FormData();
    formData.append("sunucuadresi", this.ortak.storageSunucuAdresiGetir);
    formData.append("source_ref", this.stok.ID.toString());
    formData.append("base64", this.base64Image);
    formData.append("image_name", resimAdi);
    this.bllOrtak.islem(formData, "ResimKaydet", "", true).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) {

        this.guncellenecekelement=sonuc.SonucObject;
        var bllstoklarview = new BllViewStoklar();
        bllstoklarview.ResimYoluGuncelle(this.guncellenecekelement);
        this.ortak.showBasicAlert("Başarılı","Resim Kaydedildi");
        this.kapat();

      }
      else if (sonuc.Sonuc != 1) {
        this.ortak.showBasicAlert("Hata", "Beklenmedik bir hata oluştu");
      }
    })
  }
  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stok-resim-ekle-guncelle/stok-resim-ekle-guncelle.ts